// accepts full (6 characters) and shorthand (3 characters) formats
export const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/
